import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { usePracticeSettings } from "features/practice/hooks/usePracticeSettings";

const useHealthlinkCredentials = () => {
  const tenant =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");
  const { data: practiceSettings } = usePracticeSettings();
  const isHealthlinkEnabled =
    !!practiceSettings && practiceSettings.healthLink !== false;

  const fetchHealthMailLoginDetails = async () => {
    const axiosInstance = createAxiosInstance();
    const response = await axiosInstance.get(
      `${tenant}/healthlink/credentials`
    );

    return response.data;
  };

  return useQuery({
    queryKey: ["healthlinkCredentials", tenant],
    queryFn: fetchHealthMailLoginDetails,
    enabled: !!tenant && isHealthlinkEnabled,
  });
};

export { useHealthlinkCredentials };